import { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { useLenis } from "./hooks/useLenis";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Stats } from "./components/Stats";
import { Services } from "./components/Services";
import { Approach } from "./components/Approach";
import { Events } from "./components/Events";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  useLenis();
  const [service, setService] = useState("");

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <Services onSelectService={setService} />
        <Approach />
        <Events />
        <Marquee dark={false} />
        <Contact preselectedService={service} />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
